import {
  getImpersonationSessionId,
  getImpersonationUserId,
} from '../store/impersonation';

/** Headers sent with authenticated API requests while viewing as another user. */
export function getImpersonationRequestHeaders(): Record<string, string> {
  const targetUserId = getImpersonationUserId();
  const sessionId = getImpersonationSessionId();
  if (!targetUserId || !sessionId) {
    return {};
  }
  return {
    'X-Impersonate-User-Id': targetUserId,
    'X-Impersonate-Session-Id': sessionId,
  };
}
